// extracted by mini-css-extract-plugin
module.exports = {"container":"spinner_container__KqVTv","container_item":"spinner_container_item__52CV7","rotate":"spinner_rotate__2yLI-"};